import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#f8f5f1",
  foreground: "#241a14",
  surface: "#ffffff",
  surfaceForeground: "#241a14",
  surfaceSecondary: "#f1ece5",
  surfaceSecondaryForeground: "#241a14",
  surfaceTertiary: "#e8e1d8",
  surfaceTertiaryForeground: "#241a14",
  overlay: "#ffffff",
  overlayForeground: "#241a14",
  muted: "#7a6f64",
  default: "#efe9e1",
  defaultForeground: "#241a14",
  accent: "#d94f2a",
  accentForeground: "#ffffff",
  danger: "#cd3a30",
  dangerForeground: "#ffffff",
  warning: "#e8a317",
  warningForeground: "#241a14",
  success: "#2f9e44",
  successForeground: "#241a14",
  separator: "#c4b9ac",
  glassBackground: "rgba(255, 255, 255, 0.85)",
  glassBorder: "rgba(36, 26, 20, 0.1)",
  glassHighlight: "rgba(36, 26, 20, 0.08)",
  glow0: "rgba(217, 79, 42, 0.14)",
  glow1: "rgba(242, 156, 87, 0.12)",
  glow2: "rgba(47, 158, 68, 0.08)",
  mutedForeground: "#241a14",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(36, 26, 20, 0.1)",
  overlayShadow: "rgba(36, 26, 20, 0.1)",
  fieldShadow: "rgba(36, 26, 20, 0.1)",
  fieldBorder: "rgba(36, 26, 20, 0.12)",
  fieldPlaceholder: "rgba(36, 26, 20, 0.42)",
  fieldBackground: "rgba(36, 26, 20, 0.03)",
  segment: "#ffffff",
  segmentForeground: "#241a14",
  link: "#d94f2a",
  focus: "#d94f2a",
  fieldForeground: "#241a14",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#c4b9ac",
  primary: "#d94f2a",
  primaryForeground: "#ffffff",
  secondary: "#efe9e1",
  secondaryForeground: "#241a14",
  backdrop: "rgba(22, 16, 13, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#16100d",
  foreground: "#f7f1ec",
  surface: "#241813",
  surfaceForeground: "#f7f1ec",
  surfaceSecondary: "#2b1d17",
  surfaceSecondaryForeground: "#f7f1ec",
  surfaceTertiary: "#352419",
  surfaceTertiaryForeground: "#f7f1ec",
  overlay: "#291b15",
  overlayForeground: "#f7f1ec",
  muted: "#b3a499",
  default: "#31221b",
  defaultForeground: "#f7f1ec",
  accent: "#e76a42",
  accentForeground: "#16100d",
  danger: "#e15349",
  dangerForeground: "#f7f1ec",
  warning: "#f0b13a",
  warningForeground: "#241a14",
  success: "#41b35a",
  successForeground: "#241a14",
  separator: "#4a3528",
  glassBackground: "rgba(36, 24, 19, 0.985)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.25)",
  glow0: "rgba(231, 106, 66, 0.5)",
  glow1: "rgba(242, 156, 87, 0.42)",
  glow2: "rgba(65, 179, 90, 0.32)",
  mutedForeground: "#f7f1ec",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.3)",
  overlayShadow: "rgba(0, 0, 0, 0.3)",
  fieldShadow: "rgba(0, 0, 0, 0.3)",
  fieldBorder: "rgba(255, 255, 255, 0.1)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.42)",
  fieldBackground: "rgba(255, 255, 255, 0.03)",
  segment: "#3b291f",
  segmentForeground: "#f7f1ec",
  link: "#e76a42",
  focus: "#e76a42",
  fieldForeground: "#f7f1ec",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#4a3528",
  primary: "#e76a42",
  primaryForeground: "#16100d",
  secondary: "#31221b",
  secondaryForeground: "#f7f1ec",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
